/**
 * Gate for offering custom-data layers in the FME export flow. Upload and main-map display are ungated,
 * so an org can keep custom data on the map while its FME workspace still cannot read it. Shared with
 * the server-side gate on the export endpoints.
 */
import { EXPORT_CUSTOM_DATA_FLAG } from '@civilgrid/utils/src/extract/constants';
import { useOrgResolvedFlag } from './useOrgResolvedFlag';

export { EXPORT_CUSTOM_DATA_FLAG };

/**
 * The flag with its **resolution** state. Rollout is per-organization, so callers need the two apart:
 * hiding the picker is safe while unresolved, but dropping the user's selections is not — that is only
 * correct once a flags response for the active org says the flag is off. See {@link useOrgResolvedFlag}.
 */
export function useExportCustomDataEnabled(): { resolved: boolean; enabled: boolean } {
  return useOrgResolvedFlag(EXPORT_CUSTOM_DATA_FLAG);
}
